import notificationsSlice from './notifications';


export default {
  notificationsSlice,
};
